module.exports = __webpack_public_path__ + "img/lock.f8c3c6d2.svg";